import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Accept, CallBtn, Decline } from '../styles/dialpadstyle'

export class CallInboundTheme extends Component {
  render() {
    const {
      onClickAcceptBtn,
      acceptBtn,
      acceptText,
      onClickDeclineBtn,
      declineBtn,
      declineText
    } = this.props;
    return (
      <CallBtn>
        <Accept>
          <i className={"cursorPointer"} onClick={onClickAcceptBtn}>
            <img src={acceptBtn} />
          </i>
          <span>{acceptText}</span>
        </Accept>
        <Decline>
          <i className={"cursorPointer"} onClick={onClickDeclineBtn}>
            <img src={declineBtn} />
          </i>
          <span>{declineText}</span>
        </Decline>
      </CallBtn>
    )
  }
}

CallInboundTheme.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

CallInboundTheme.contextTypes = {
  __: PropTypes.func
};

export default CallInboundTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/CallInboundTheme.js